import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import * as _ from 'lodash';
import moment from 'moment/moment';

class PickUpTimeComponent extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {};
  }

  static getDerivedStateFromProps(props) {
    if (_.isEmpty(props.selectedTime)) {
      const pickUpTimeLabel = localStorage.getItem("pickUpTimeLabel");
      if(pickUpTimeLabel){
        props.changeTime({
          value: moment(pickUpTimeLabel, 'HH:mm').format('HHmm'),
          label: pickUpTimeLabel,
        });
      }
      else if (!_.isEmpty(props.timeData)) {
        props.changeTime(props.timeData[0]);
      }
    }
    return null;
  }

  handleChange(selectedOption) {
     this.props.changeTime(selectedOption);
  }

  render() {
    const {handleChange} = this;
    const {classNames, timeData, selectedTime} = this.props;
    return (
      <div className={classNames}>
        <span className="icon icon-clock">
        </span>
        <div className='page-header__select-wrapper page-header__select-wrapper--time'>
          <Select
            name="form-timetable"
            clearable={false}
            value={selectedTime}
            options={timeData}
            searchable={false}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
}

PickUpTimeComponent.propTypes = {
  classNames: PropTypes.string,
  timeData: PropTypes.array,
  changeTime: PropTypes.func
};

export default PickUpTimeComponent;


// WEBPACK FOOTER //
// ./src/components/PickUpTime/PickUpTime.js